import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateBonuses = (params) => {
    return axios.post(`${backendHost}/api/admin/bonuses/update`, params);
};

export {
    postUpdateBonuses
}